module.exports = __webpack_public_path__ + "images/f9dad12ef265f27ded0438aad3f31f0502661dd6c30f86754ddf4077e46425a8.svg";